<template>
  <div class="cv-optimization-container">
    <div v-if="optimizationStatus === 'loading' || optimizationStatus === 'error'" class="optimization-loading">
      <template v-if="optimizationStatus === 'loading'">
        <img src="https://files.wondercv.com/icon/loading.gif" class="loading-icon" alt="">
        <span>内容润色中，请稍后...</span>
      </template>
      <template v-else>
        <div class="error-tips">AI 开小差了，请重新生成试试</div>
        <div class="retry-btn" @click="handleClickAiOptimization">重新润色</div>
      </template>
      <i class="iconfont iconclose" @click="handleCloseOptimization"></i>
    </div>
    <div v-else-if="optimizationStatus === 'over'" class="optimization-result-content">
      <div class="optimization-header">
        <div class="desc-content">
          <img class="logo" src="https://logo.wondercv.com/banners/33KGUVOwLyzHmma.png" alt="">
          <span class="txt">内容润色完成</span>
        </div>
        <div v-if="isMemberAccount" class="btn-group">
          <div class="btn-item" @click="handleClickAiOptimization">重新润色</div>
          <div class="btn-item" @click="useOptimizationContent">使用当前内容</div>
        </div>
        <template v-else>
          <i class="iconfont iconclose"></i>
        </template>
      </div>
      <div v-if="isMemberAccount" class="optimization-content" v-html="optimizationResult"></div>
      <div v-else class="normal-content">
        <div class="common-btn" @click="handleOpenMemberDialog">开通会员查看结果</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { cvMixin } from '../../../../../assets/js/mixins'
export default {
  mixins: [cvMixin],
  data() {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapState('me', [ 'personInfo' ]),
    ...mapState('editor', ['optimizationStatus', 'optimizationResult']),
    isMemberAccount() {
      return this.personInfo.is_membership
    },
  },
  methods: {
    ...mapMutations('editor', ['setOptimizationData']),
    handleOpenMemberDialog() {
      this.$emit('handleSaveCurrentForm')
      this.$store.dispatch('app/setAlertData', {
        show: true,
        type: 'upVip',
        browseType: 'aiOptimization'
      })
    },
    handleCloseOptimization() {
      this.setOptimizationData({
        status: 'initial',
        result: ''
      })
    },
    useOptimizationContent() {
      const alertData = {
				...this.alertData,
				confirmButtonText: '确认使用',
				cancelButtonText: '我再想想',
				messageContent: `AI生成后的内容可能还需要您自主微调哦，是否使用当前润色内容？`,
				confirm: async close => {
					this.$emit('useOptimizationContent', this.optimizationResult)
					close()
				},
				cancel: close => {
					close()
				},
			}
			this.setAlertData(alertData)
    }
  }
}
</script>
<style scoped lang="scss">
.cv-optimization-container {
  .optimization-loading {
    display: flex;
    align-items: center;
    position: relative;
    height: 42px;
    margin-top: 9px;
    border-radius: 4px;
    color: #fff;
    background-color: #06094F;
    padding: 0 16px;
    font-size: 12px;
    .loading-icon {
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }
    .iconfont {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 16px;
      font-size: 10px;
      cursor: pointer;
    }
    .retry-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 72px;
      height: 24px;
      border-radius: 24px;
      border: 1px solid rgba($color: #fff, $alpha: 0.4) !important;
      margin-left: 12px;
      cursor: pointer;
    }
  }
  .optimization-result-content {
    margin-top: 8px;
    background-color: #06094F;
    border-radius: 8px;
    overflow: hidden;
    .optimization-header {
      position: relative;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 48px;
      background-image: url('https://logo.wondercv.com/banners/e87iy2LFjkLt6aR.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      box-sizing: border-box;
      padding: 16px 16px 8px 16px;
      .desc-content {
        display: flex;
        align-items: center;
        .logo {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
        .txt {
          color: #fff;
          font-size: 14px;
        }
      }
      .btn-group {
        display: flex;
        align-items: center;
        .btn-item {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 12px;
          height: 24px;
          color: #fff;
          border-radius: 24px;
          border: 1px solid rgba($color: #fff, $alpha: 0.4) !important;
          font-size: 12px;
          cursor: pointer;
          &:nth-child(1):hover {
            background-color: rgba($color: #fff, $alpha: 0.2);
          }
          &:nth-child(2) {
            background-color: #2D30A6;
            border-color: transparent !important;
            margin-left: 8px;
            &:hover {
              background-color: #4448DD;
            }
          }
        }
      }
      .iconfont {
        color: #fff;
        font-size: 14px;
      }
    }
    .optimization-content {
      min-height: 132px;
      font-size: 12px;
      line-height: 15px;
      overflow-x: hidden;
      color: #fff;
      padding: 16px;
      box-sizing: border-box;
      white-space: pre-line;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .normal-content {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 132px;
      background-image: url('https://logo.wondercv.com/banners/nOd2mQh2XR089zT.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      padding-top: 30px;
      box-sizing: border-box;
      .common-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 25px;
        background-color: #FF5733;
        color: #fff;
        border-radius: 22px;
        box-sizing: border-box;
        cursor: pointer;
        padding: 0 24px;
        width: max-content;
        &:hover {
          background-color: #FF8569;
        }
      }

    }
  }
}
</style>